<div *ngIf="!isLoading; else skeleton">
  <div class="grid__col-12 guts-p-b-0">
    <div
      *ngIf="suptitle"
      class="h4 color-ebony-a61"
      data-dgprop-item-clicked="Suptitle"
    >
      {{ suptitle }}
    </div>
    <h1
      class="suggested-section__title h3"
      data-dgprop-item-clicked="Title"
      data-dgat="suggested-section-ttl"
    >
      {{ title }}
    </h1>
  </div>
  <div *ngIf="visibleSuggestions" class="grid">
    <div
      class="use-updated-content-card"
      *ngFor="let suggestion of visibleSuggestions; index as index"
      dgxIntersectionObserver
      (onIntersection)="onIntersection(suggestion, index)"
      [ngClass]="{
        'grid__col-sm-6': perRow === 2,
        'grid__col-md-4': perRow == 3,
        'grid__col-md-3': perRow == 4,
        'grid__col-xs-12 grid__col-sm-4': perRow == 3
      }"
      data-dgat="suggested-section-d3f"
      [attr.data-suggestion-id]="suggestion.userSuggestionId"
      #suggestionElements
    >
      <div
        [ngClass]="{
          'suggested-section__recommendation-header':
            section.resourceSection === 'ContinueLearning' &&
            suggestion.rowHasHeader
        }"
      >
        <dgx-user-recommendation-header
          *ngIf="suggestion.recommendation"
          [item]="getRecommendationHeader(suggestion)"
          [maxLines]="2"
        >
        </dgx-user-recommendation-header>
      </div>
      <dgx-tile-launcher
        [attr.data-dgprop-user-suggestion-id]="suggestion.userSuggestionId"
        class="suggested-section__tile"
        [item]="suggestion.reference"
        [recommendationInfo]="suggestion | recommendationInfo"
        [modifyOptionsFn]="suggestion.modifyOptionsFn"
        [actionContext]="suggestion"
        [hideDescription]="true"
        [showStatistics]="showStatistics"
        [assignmentDueDate]="suggestion.suggestionDetails.dueDate"
        [section]="expectedResourceSection"
        [tileIndex]="index"
        [expandCard]="
          contentCardService.shouldCardExpand(index, expectedResourceSection)
            | async
        "
        [initialTagAction]="suggestion.suggestionDetails.action"
        (dismissTagRecommendation)="dismiss($event, suggestion, index)"
        (dismiss)="dismiss($event, suggestion, index)"
        tabindex="0"
      >
      </dgx-tile-launcher>
      <!-- </ng-template> -->
    </div>
    <div
      *ngIf="isExpanded && viewMore"
      [ngClass]="{
        'grid__col-sm-6': perRow == 2,
        'grid__col-md-4': perRow == 3,
        'grid__col-md-3': perRow == 4,
        'grid__col-xs-6 grid__col-sm-4': perRow == 3
      }"
    >
      <a
        [href]="viewMore.href"
        [class.suggested-section__view-more--opportunities]="
          section.resourceSection === 'Opportunities'
        "
        (click)="viewMoreClicked($event)"
        class="tile suggested-section__view-more"
        data-dgat="suggested-section-0cd"
      >
        <div class="suggested-section__view-more-icon">
          <df-icon [icon]="viewMore.icon" size="large"></df-icon>
        </div>
        <div class="suggested-section__view-more-title guts-m-v-2 guts-m-h-3">
          {{ viewMore.title }}
        </div>
        <div class="color-blue guts-m-h-3" data-dgat="suggested-section-0cd">
          {{ viewMore.link }}
        </div>
      </a>
    </div>
  </div>
  <div class="grid__col-12 guts-p-v-0 l_flex-row">
    <button
      *ngIf="showExpand"
      [disabled]="isLoadingMore"
      (click)="onToggleExpanded($event)"
      class="center-item suggested-section__expand"
      df-button
      dfButtonType="passive"
      data-dgat="suggested-section-735"
    >
      <span *ngIf="isLoadingMore" class="l_flex m-l_flex l_flex-middle">
        {{ 'Core_Loading' | translate }}
        <df-spinner
          class="suggested-section__spinner guts-m-l-1"
          spinnerContext="button"
        ></df-spinner>
      </span>
      <span *ngIf="!isLoadingMore">
        {{ expandTitle }}
        <df-icon
          [icon]="isExpanded ? 'chevron-up' : 'chevron-down'"
          size="small"
        ></df-icon>
      </span>
    </button>
  </div>
</div>
<ng-template #skeleton>
  <div class="grid__col-12 guts-p-b-half">
    <h1>
      <div
        class="
          skeleton-container skeleton__line
          suggested-section__title--loading
        "
      ></div>
    </h1>
  </div>
  <div
    class="grid suggested-section__loading-container"
    data-dgprop-item-clicked="Skeletons"
  >
    <dgx-skeleton
      *ngFor="let i of stubArray()"
      [type]="
        expectedResourceSection === 'Opportunities' ? 'opportunity' : 'tile'
      "
      [ngClass]="{
        'grid__col-sm-6': perRow == 2,
        'grid__col-md-4': perRow == 3,
        'grid__col-md-3': perRow == 4,
        'grid__col-xs-6 grid__col-sm-4': perRow == 3
      }"
      data-dgat="suggested-section-52a"
    ></dgx-skeleton>
  </div>
  <div class="grid__col-12">
    <div
      class="
        center-item
        skeleton-container skeleton__line
        suggested-section__expand--loading
      "
    ></div>
  </div>
</ng-template>
